var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcClearLookUpUserNameText(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icClearLookUpUserNameText") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filter-Search-Username",
    transform: "translate(-331.000000, -133.000000)",
    fill: "#B8B8B8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.06066,140 L340.826574,138.234086 C341.115689,137.944971 341.12132,137.464466 340.828427,137.171573 C340.533492,136.876638 340.059831,136.879509 339.765914,137.173426 L338,138.93934 L336.234086,137.173426 C335.944971,136.884311 335.464466,136.87868 335.171573,137.171573 C334.876638,137.466508 334.879509,137.940169 335.173426,138.234086 L336.93934,140 L335.173426,141.765914 C334.884311,142.055029 334.87868,142.535534 335.171573,142.828427 C335.466508,143.123362 335.940169,143.120491 336.234086,142.826574 L338,141.06066 L339.765914,142.826574 C340.055029,143.115689 340.535534,143.12132 340.828427,142.828427 C341.123362,142.533492 341.120491,142.059831 340.826574,141.765914 L339.06066,140 Z M338,147 C334.134007,147 331,143.865993 331,140 C331,136.134007 334.134007,133 338,133 C341.865993,133 345,136.134007 345,140 C345,143.865993 341.865993,147 338,147 Z",
    id: "icClearLookUpUserNameText"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClearLookUpUserNameText);
export default __webpack_public_path__ + "static/media/icClearLookUpUserNameText.54aee4b257ffc64ef890b78e95f08942.svg";
export { ForwardRef as ReactComponent };